module.exports = __webpack_public_path__ + "static/media/Protocol-Formoplast-OSA-16.02.2018_clean.efb489a0.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2018/Protocol-Formoplast-OSA-16.02.2018_clean.pdf
// module id = 142
// module chunks = 0